import SideMenu from '@/containers/side-menu/SideMenu.vue';
import DashboardParking from '@/pages/dashboard-parking/DashboardParking';

export default {
  path: '/dashboard-parking',
  name: 'DashboardParking',
  components: {
    mainContent: DashboardParking,
    mainMenu: SideMenu,
  },
  meta: {
    role: {
      sectorId: 'dashboard',
    },
    breadcrumb: {
      title: 'Dashboard',
      paths: [{ title: 'Monitoramento' }],
    },
  },
};
